import React, { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../store/auth/login/actions";
import { Navigate, useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { LoadingContext } from "../Utility/spinner/LoadingContext";

const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setIsLoading } = useContext(LoadingContext);
  const isUserLogout = useSelector((state) => state.login.isUserLogout);

  useEffect(() => {
    setIsLoading(false);
    dispatch(logoutUser({ navigate }));
  }, [dispatch, navigate, setIsLoading]);

  useEffect(() => {
    if (isUserLogout) {
      enqueueSnackbar("You have successfully logged out", { variant: "success" });
    }
  }, [isUserLogout]);

  if (isUserLogout) {
    return <Navigate to="/login" replace />;
  }

  return null;
};

export default Logout;
